import React from 'react';
import { useState } from 'react'; 
  
function Contact() { 

 const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [comment, setComment] = useState("");
  const [message, setMessage] = useState("");
 

  let handleSubmit = async (e) => {
    e.preventDefault();

    const myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json');

 const url = 'https://osgh.gcs-us.com/index.php/contact/create'
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({ name, email, subject, mobileNumber, comment}),
        myHeaders
    };
    fetch(url, requestOptions)
        .then(response => console.log('Submitted successfully'))
        .catch(error => console.log('Form submit error', error))

    };
        return (  
  <React.Fragment> 
  <main id="main">

    <div class="breadcrumbs" data-aos="fade-in">
      <div class="container">
        <h2>Contact Us</h2>
        <p>Est dolorum ut non facere possimus quibusdam eligendi voluptatem. Quia id aut similique quia voluptas sit quaerat debitis. Rerum omnis ipsam aperiam consequatur laboriosam nemo harum praesentium. </p>
      </div>
    </div>

    <section id="contact" class="contact">
      <div data-aos="fade-up">
        
      </div>

      <div class="container" data-aos="fade-up">

        <div class="row mt-5">

          <div class="col-lg-4"> 
            <div class="info">
              <div class="address">
                <i class="bi bi-geo-alt"></i>
                <h4>Location:</h4>
                <p>A108 Adam Street, New York, NY 535022</p>
              </div>

              <div class="email">
                <i class="bi bi-envelope"></i>
                <h4>Email:</h4>
                <p>info@example.com</p>
              </div>

              <div class="phone">
                <i class="bi bi-phone"></i>
                <h4>Call:</h4>
                <p>+1 5589 55488 55s</p>
              </div>

            </div>

          </div>

          <div class="col-lg-8 mt-5 mt-lg-0">

            <form onSubmit={handleSubmit}>
              <div class="row">
                <div class="col-md-6 form-group">
                  <input type="text" value={name} onChange={(e) => setName(e.target.value)} class="form-control" id="name" placeholder="Your Name" required />
                </div>
                <div class="col-md-6 form-group mt-3 mt-md-0">
                  <input type="email" value={email} class="form-control" onChange={(e) => setEmail(e.target.value)} id="email" placeholder="Your Email" required /> 
                </div>
              </div>
              <div class="form-group mt-3">
    <input type="text" value={subject} class="form-control"  onChange={(e) => setSubject(e.target.value)} id="subject" placeholder="Subject" required />
              </div>
              <div class="form-group mt-3">
    <input type="text" value={mobileNumber} class="form-control"  onChange={(e) => setMobileNumber(e.target.value)} id="mobileNumber" placeholder="mobile" required />
              </div>
              <div class="form-group mt-3">
                <textarea class="form-control" value={comment} onChange={(e) => setComment(e.target.value)} rows="5" placeholder="Message" required></textarea>
              </div>
              <div class="my-3">
                <div class="loading">Loading</div>
                <div class="error-message"></div>
                <div className="message">{message ? <p>{message}</p> : null}</div>
              </div>
              <div class="text-center"><button type="submit">Send Message</button></div>
            </form>

          </div>

        </div>

      </div>
    </section>

  </main>
  </React.Fragment> 
        )  
}  
  
export default Contact  